import IcComputer from "@/assets/svg/ic_computer.svg?react";
import IcIfpd from "@/assets/svg/ic_ifpd.svg?react";
import IcSelected from "@/assets/svg/ic_selected.svg?react";
import recordStore from "@/store/record.store";
import { ICustomeDevcie } from "@/types/device";

function DeviceItem(props: {
  device: ICustomeDevcie;
  selected?: boolean;
  onSelect?: (device: ICustomeDevcie) => void;
}) {
  const { device, selected, onSelect } = props;
  const isOnline = recordStore((state) => state.isOnline);

  const handleClick = () => {
    if (selected) return;
    onSelect?.(device);
  };
  return (
    <div
      key={device.code}
      className={`p-x-4 p-y-1 flex items-center gap-3 ${isOnline ? 'cursor-pointer' : 'cursor-not-allowed'} hover:bg-mx-secondary hover:bg-op-05`}
      onClick={handleClick}
    >
      {device.type === "computer" ? (
        <IcComputer className="w-10 h-10" />
      ) : (
        <IcIfpd className="w-10 h-10" />
      )}
      <div className="flex-1 overflow-x-hidden">
        <div className="text-3.5 c-mx-secondary mx-text-ellipsis">
          {device.name}
        </div>
        <div className="text-3 c-mx-tertiary">{device.code}</div>
      </div>
      {selected && <IcSelected className="w-5 h-5"></IcSelected>}
    </div>
  );
}

export default DeviceItem;
